import React from "react";
import BookingCommissionTable from "./Components/BookingCommissionTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const BookingCommissionList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Booking Commission List</HeadingOne>
                    <AddItemBtn url="add-booking-commission" title="Add Booking Commission" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <BookingCommissionTable />
            </div>
        </PageBody>
    );
};

export default BookingCommissionList;
